"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrappedAsset = exports.ERC20Asset = exports.EVMGasToken = void 0;
const chain_1 = require("../chain");
const asset_1 = require("./asset");
const EVMGasTokenDecimals = 18;
/**
 * Representation of the gas token used to pay fees in an EVM.
 * It is also known as the native asset of an EVM.
 */
class EVMGasToken extends asset_1.TokenAsset {
    type = asset_1.TokenType.Gas;
    constructor(assetId, name, symbol) {
        super(assetId, name, symbol, EVMGasTokenDecimals);
    }
}
exports.EVMGasToken = EVMGasToken;
/**
 * Representation of an ERC20 smart contract.
 */
class ERC20Asset extends asset_1.TokenAsset {
    type = asset_1.TokenType.ERC20;
    address;
    constructor(address, name, symbol, decimals) {
        super(address, name, symbol, decimals);
        this.address = address;
    }
    getAddress() {
        return this.address;
    }
}
exports.ERC20Asset = ERC20Asset;
/**
 * Representation of a wrapped gas token smart contract.
 * Also known as wrapped native. In the Juneo network it is deployed as the wJUNE.
 */
class WrappedAsset extends ERC20Asset {
    type = asset_1.TokenType.Wrapped;
    adapter;
    constructor(address, name, symbol, decimals) {
        super(address, name, symbol, decimals);
        this.adapter = new chain_1.WrappedContractAdapter(address);
    }
}
exports.WrappedAsset = WrappedAsset;
